import Theme from "../Theme"

export const SidebarData = [
    {
        id: 1,
        title: "Dashboard",
        icon: Theme.HomeIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "dashboard"
    },
    {
        id: 2,
        title: "Registration module",
        icon: Theme.HomeIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "registration",
        subNav: [
            {
                title: "View Registered Farmers",
                slug: [ "registration", "view_farmers" ],
                icon: Theme.CalculatorIcon
            },
            {
                title: "Register Farmer",
                slug: [ "registration", "register_farmer" ],
                icon: Theme.ShoppingIcon
            },
        ]
    },
    {
        id: 6,
        title: "Production Data",
        icon: Theme.HomeIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "production"
    },
    {
        id: 2,
        title: "Knowlegde Transfer",
        icon: Theme.HomeIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "messages",
        subNav: [
            {
                title: "Send Messages",
                slug: [ "messages", "send_sms" ],
                icon: Theme.CalculatorIcon
            },
            {
                title: "View Sent Messages",
                slug: [ "messages", "view_sms" ],
                icon: Theme.ShoppingIcon
            },
        ]
    },
    {
        id: 3,
        title: "Data Aggregation",
        icon: Theme.HomeIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "data",
        subNav: [
            {
                title: "FFS Groups",
                slug: [ "data", "dashboard" ],
                icon: Theme.CalculatorIcon
            },
            {
                title: "View FFSGs",
                slug: [ "data", "dashboard" ],
                icon: Theme.ShoppingIcon
            },
        ]
    },
    {
        id: 4,
        title: "Payment Services",
        icon: Theme.HomeIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "payments",
        subNav: [
            {
                title: "Add Payment",
                slug: [ "payments", "payments" ],
                icon: Theme.CalculatorIcon
            },
            {
                title: "Water Fees Payments",
                slug: [ "payments", "water_payments" ],
                icon: Theme.CalculatorIcon
            },
            {
                title: "Membership Payments",
                slug: [ "payments", "membership_payments" ],
                icon: Theme.CalculatorIcon
            },
            {
                title: "Buying of Shares",
                slug: [ "payments", "share_payments" ],
                icon: Theme.CalculatorIcon
            },
            
        ]
    },
    {
        id: 5,
        title: "Leadership",
        icon: Theme.HomeIcon,
        iconClosed: Theme.DownIcon,
        iconOpened: Theme.UpIcon,
        slug: "leaders",
        subNav: [
            // {
            //     title: "Add Leader",
            //     slug: [ "leaders", "add_leader" ],
            //     icon: Theme.CalculatorIcon
            // },
            {
                title: "Oyam Cooperative Society Board Members",
                slug: [ "leaders", "view_leaders", "cooperative" ],
                icon: Theme.CalculatorIcon
            },
            {
                title: "Oyam Water Users Association Members",
                slug: [ "leaders", "view_leaders", "iwua" ],
                icon: Theme.CalculatorIcon
            },
            {
                title: "Irrigation Water User Committees Leadership",
                slug: [ "leaders", "view_leaders", "iwuc" ],
                icon: Theme.CalculatorIcon
            },
            {
                title: "FFSG Leaders",
                slug: [ "leaders", "view_leaders", "group" ],
                icon: Theme.CalculatorIcon
            }
        ]
    },
]